const question6 = {
    'question': 'Kiedy udać się do psychologa, a kiedy do lekarza psychiatry?',
    'answer': 'Ogólnie rzecz biorąc, psychologowie i psychiatrzy zajmują się różnymi aspektami zdrowia psychicznego. Psycholodzy specjalizują się w pomaganiu ludziom w radzeniu sobie z problemami emocjonalnymi i behawioralnymi. Psychiatrzy są lekarzami, którzy specjalizują się w diagnostyce i leczeniu farmakologicznym zaburzeń psychicznych.',
}

export default question6;